import { Tooltip as ReactTooltip } from 'react-tooltip';
import { Card, Form, Row, Col } from 'react-bootstrap';
import { Button, ButtonGroup } from 'react-bootstrap';
import 'react-datepicker/dist/react-datepicker.css';
import HeaderQuoteAi from './headerQuoteAi';
import SidebarQuoteAi from '../quote/sidebarQuoteAi';
import { useNavigate } from 'react-router-dom';
import RightHeaderPage from './rightHeader';

const UnderwritingInformationPage = () => {
  const navigate = useNavigate();

  return (
    <>
      <div id="quoteAi">
        <HeaderQuoteAi />
        <div className="QuoteDashboard">
          <div className="main">
            <div className="pageformBloack">
              <div className=" container-fluid ">
                <div className="row">
                  <div className="col-12 col-md-12 col-lg-2">
                    <div className="sidebar-visible">
                      <SidebarQuoteAi />
                    </div>
                  </div>
                  <div className="col-12 col-md-12 col-lg-8 gx-2 main-quotescroll">
                    <div className="whiteBoxCont ">
                      <div className="quote_buttongroup">
                        <div className="form_action_buttons mb-2">
                          <ButtonGroup>
                            <Button
                              variant="outline-back"
                              className="button-gap"
                              onClick={() => navigate('/quoteAI/IncludedExcludedOfficerPage')}
                            >
                              Back
                            </Button>
                            <Button
                              variant="outline-next"
                              className="button-gap"
                              onClick={() => navigate('/quoteAI/AdditionalFormPage')}
                            >
                              Next
                            </Button>
                          </ButtonGroup>
                          <ButtonGroup>
                            <Button variant="outline-cancel" className="button-gap">
                              Cancel
                            </Button>
                            <Button variant="primary-save" className="button-gap">
                              Save
                            </Button>
                          </ButtonGroup>
                        </div>
                      </div>
                      <div className="scrollable-content">
                        <div className="formcard-container mrgTop">
                          {/* Insured Information Section */}
                          <Card className="mb-4 formpage-card">
                            <Card.Header className="formpage-card-header">
                              Underwriting Information
                            </Card.Header>
                            <Card.Body>
                              <Row>
                                <Col xs={12} sm={12} md={12} className="mb-3">
                                  <Form.Group className="form-section-group">
                                    <Form.Label style={{ lineHeight: '1.5' }}>
                                      Any 24 hour operation?
                                      <i
                                        className="info-icon"
                                        data-tooltip-id="my-tooltip"
                                        data-tooltip-content="Any 24 hour operation?"
                                      >
                                        <svg
                                          width="16"
                                          height="16"
                                          viewBox="0 0 13 14"
                                          fill="none"
                                          xmlns="http://www.w3.org/2000/svg"
                                        >
                                          <path
                                            d="M8.04523 4.83314L6.04126 4.82643L6.34517 2.91284L8.34914 2.91955L8.04523 4.83314Z"
                                            fill="#76D1B9"
                                          />
                                          <path
                                            d="M5.90964 5.65674L5.90913 5.65994L4.95381 5.65674L4.6499 7.57033L5.60523 7.57353L5.04832 11.0802L7.05229 11.0869L7.91361 5.66347L5.90964 5.65674Z"
                                            fill="#76D1B9"
                                          />
                                          <path
                                            d="M12.0013 2.87256C11.817 2.60961 11.608 2.36014 11.3743 2.1264C11.1428 1.89491 10.8956 1.6859 10.6349 1.50611C9.70892 0.849874 8.61216 0.499268 7.46148 0.499268H5.53768C4.06337 0.499268 2.67445 1.07686 1.6249 2.1264C0.577597 3.17372 0 4.56264 0 6.03695V7.96301C0 9.17438 0.391058 10.3273 1.11022 11.2825C1.2653 11.4892 1.43836 11.687 1.62487 11.8735C1.80915 12.0578 2.00468 12.2286 2.20922 12.3815C3.16439 13.1074 4.3218 13.5007 5.53768 13.5007H7.46148C8.9358 13.5007 10.3247 12.9231 11.3743 11.8735C12.4216 10.8262 12.9992 9.43732 12.9992 7.96301V6.03695C12.9992 4.89074 12.6508 3.79624 12.0013 2.87256Z"
                                            fill="none"
                                            stroke="#76D1B9"
                                          />
                                        </svg>
                                      </i>
                                      <ReactTooltip
                                        id="my-tooltip"
                                        style={{ backgroundColor: '#2563eb' }}
                                      />
                                    </Form.Label>
                                    <Row className="value-label-row">
                                      <Col
                                        xs={6}
                                        sm={2}
                                        md={1}
                                        className="d-flex align-items-center"
                                      >
                                        <Form.Check
                                          type="radio"
                                          className="me-2"
                                          id="yes-radio"
                                          name="hour-operation"
                                        />
                                        <Form.Label htmlFor="yes-radio" className="mb-0">
                                          Yes
                                        </Form.Label>
                                      </Col>
                                      <Col
                                        xs={6}
                                        sm={2}
                                        md={1}
                                        className="d-flex align-items-center"
                                      >
                                        <Form.Check
                                          type="radio"
                                          className="me-2"
                                          id="no-radio"
                                          name="hour-operation"
                                        />
                                        <Form.Label htmlFor="no-radio" className="mb-0">
                                          No
                                        </Form.Label>
                                      </Col>
                                    </Row>
                                  </Form.Group>
                                </Col>
                                <Col xs={12} sm={12} md={12} className="mb-3">
                                  <Form.Group className="form-section-group">
                                    <Form.Label style={{ lineHeight: '1.5' }}>
                                      During the last five years, has any applicant been indicted
                                      for or convicted for fraud, bribery, arson, or any other
                                      arson-related crime?
                                      <i
                                        className="info-icon"
                                        data-tooltip-id="my-tooltip"
                                        data-tooltip-content="During the last five years, has any applicant been indicted for or convicted for fraud, bribery, arson, or any other arson-related crime?"
                                      >
                                        <svg
                                          width="16"
                                          height="16"
                                          viewBox="0 0 13 14"
                                          fill="none"
                                          xmlns="http://www.w3.org/2000/svg"
                                        >
                                          <path
                                            d="M8.04523 4.83314L6.04126 4.82643L6.34517 2.91284L8.34914 2.91955L8.04523 4.83314Z"
                                            fill="#76D1B9"
                                          />
                                          <path
                                            d="M5.90964 5.65674L5.90913 5.65994L4.95381 5.65674L4.6499 7.57033L5.60523 7.57353L5.04832 11.0802L7.05229 11.0869L7.91361 5.66347L5.90964 5.65674Z"
                                            fill="#76D1B9"
                                          />
                                          <path
                                            d="M12.0013 2.87256C11.817 2.60961 11.608 2.36014 11.3743 2.1264C11.1428 1.89491 10.8956 1.6859 10.6349 1.50611C9.70892 0.849874 8.61216 0.499268 7.46148 0.499268H5.53768C4.06337 0.499268 2.67445 1.07686 1.6249 2.1264C0.577597 3.17372 0 4.56264 0 6.03695V7.96301C0 9.17438 0.391058 10.3273 1.11022 11.2825C1.2653 11.4892 1.43836 11.687 1.62487 11.8735C1.80915 12.0578 2.00468 12.2286 2.20922 12.3815C3.16439 13.1074 4.3218 13.5007 5.53768 13.5007H7.46148C8.9358 13.5007 10.3247 12.9231 11.3743 11.8735C12.4216 10.8262 12.9992 9.43732 12.9992 7.96301V6.03695C12.9992 4.89074 12.6508 3.79624 12.0013 2.87256Z"
                                            fill="none"
                                            stroke="#76D1B9"
                                          />
                                        </svg>
                                      </i>
                                      <ReactTooltip
                                        id="my-tooltip"
                                        style={{ backgroundColor: '#2563eb' }}
                                      />
                                    </Form.Label>
                                    <Row className="value-label-row">
                                      <Col
                                        xs={6}
                                        sm={2}
                                        md={1}
                                        className="d-flex align-items-center"
                                      >
                                        <Form.Check
                                          type="radio"
                                          className="me-2"
                                          id="yes-radio"
                                          name="fraud-bribery-arson"
                                        />
                                        <Form.Label htmlFor="yes-radio" className="mb-0">
                                          Yes
                                        </Form.Label>
                                      </Col>
                                      <Col
                                        xs={6}
                                        sm={2}
                                        md={1}
                                        className="d-flex align-items-center"
                                      >
                                        <Form.Check
                                          type="radio"
                                          className="me-2"
                                          id="no-radio"
                                          name="fraud-bribery-arson"
                                        />
                                        <Form.Label htmlFor="no-radio" className="mb-0">
                                          No
                                        </Form.Label>
                                      </Col>
                                    </Row>
                                  </Form.Group>
                                </Col>

                                <Col xs={12} sm={12} md={12} className="mb-3">
                                  <Form.Group className="form-section-group">
                                    <Form.Label style={{ lineHeight: '1.5' }}>
                                      Has the Insured or any partner(s) within the past five years
                                      declared bankruptcy or had a tax lien, judgment, foreclosure,
                                      or repossession?
                                      <i
                                        className="info-icon"
                                        data-tooltip-id="my-tooltip"
                                        data-tooltip-content="Has the Insured or any partner(s) within the past five years declared bankruptcy or had a tax lien, judgment, foreclosure, or repossession?"
                                      >
                                        <svg
                                          width="16"
                                          height="16"
                                          viewBox="0 0 13 14"
                                          fill="none"
                                          xmlns="http://www.w3.org/2000/svg"
                                        >
                                          <path
                                            d="M8.04523 4.83314L6.04126 4.82643L6.34517 2.91284L8.34914 2.91955L8.04523 4.83314Z"
                                            fill="#76D1B9"
                                          />
                                          <path
                                            d="M5.90964 5.65674L5.90913 5.65994L4.95381 5.65674L4.6499 7.57033L5.60523 7.57353L5.04832 11.0802L7.05229 11.0869L7.91361 5.66347L5.90964 5.65674Z"
                                            fill="#76D1B9"
                                          />
                                          <path
                                            d="M12.0013 2.87256C11.817 2.60961 11.608 2.36014 11.3743 2.1264C11.1428 1.89491 10.8956 1.6859 10.6349 1.50611C9.70892 0.849874 8.61216 0.499268 7.46148 0.499268H5.53768C4.06337 0.499268 2.67445 1.07686 1.6249 2.1264C0.577597 3.17372 0 4.56264 0 6.03695V7.96301C0 9.17438 0.391058 10.3273 1.11022 11.2825C1.2653 11.4892 1.43836 11.687 1.62487 11.8735C1.80915 12.0578 2.00468 12.2286 2.20922 12.3815C3.16439 13.1074 4.3218 13.5007 5.53768 13.5007H7.46148C8.9358 13.5007 10.3247 12.9231 11.3743 11.8735C12.4216 10.8262 12.9992 9.43732 12.9992 7.96301V6.03695C12.9992 4.89074 12.6508 3.79624 12.0013 2.87256Z"
                                            fill="none"
                                            stroke="#76D1B9"
                                          />
                                        </svg>
                                      </i>
                                      <ReactTooltip
                                        id="my-tooltip"
                                        style={{ backgroundColor: '#2563eb' }}
                                      />
                                    </Form.Label>
                                    <Row className="value-label-row">
                                      <Col
                                        xs={6}
                                        sm={2}
                                        md={1}
                                        className="d-flex align-items-center"
                                      >
                                        <Form.Check
                                          type="radio"
                                          className="me-2"
                                          id="bankruptcy-yes"
                                          name="bankruptcy-history"
                                        />
                                        <Form.Label htmlFor="bankruptcy-yes" className="mb-0">
                                          Yes
                                        </Form.Label>
                                      </Col>
                                      <Col
                                        xs={6}
                                        sm={2}
                                        md={1}
                                        className="d-flex align-items-center"
                                      >
                                        <Form.Check
                                          type="radio"
                                          className="me-2"
                                          id="bankruptcy-no"
                                          name="bankruptcy-history"
                                        />
                                        <Form.Label htmlFor="bankruptcy-no" className="mb-0">
                                          No
                                        </Form.Label>
                                      </Col>
                                    </Row>
                                  </Form.Group>
                                </Col>
                              </Row>
                            </Card.Body>
                          </Card>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-12 col-md-12 col-lg-2">
                    <div className="sticky-right-top">
                      <RightHeaderPage />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
export default UnderwritingInformationPage;
